import type { Locale } from '../types';

const tr = {
  launcher: 'Hata bildir / destek',
  edgeLabel: 'Destek',
  title: 'Destek',
  subtitle: 'Sorun bildir, öneri yaz, cevabı burada gör',
  close: 'Kapat',
  back: 'Geri',
  tabs: { new: 'Yeni Bildirim', mine: 'Bildirimlerim', status: 'Durum', pano: 'İstatistik' },
  form: {
    type: 'Tür',
    types: { bug: 'Hata', suggestion: 'Öneri', question: 'Soru' },
    priority: 'Öncelik',
    priorities: { low: 'Düşük', normal: 'Normal', high: 'Yüksek', urgent: 'Acil' },
    title: 'Başlık',
    titlePlaceholder: 'Kısaca ne oldu?',
    description: 'Açıklama',
    descriptionPlaceholder: 'Ne yapmaya çalışıyordunuz, ne oldu? Mümkünse adım adım yazın.',
    name: 'Adınız',
    email: 'E-posta',
    screenshot: 'Ekran görüntüsü',
    capture: 'Ekranı yakala',
    upload: 'Dosya yükle',
    remove: 'Kaldır',
    capturing: 'Yakalanıyor…',
    select: { hint: 'Yakalanacak alanı sürükleyerek seçin', full: 'Tüm sayfa', cancel: 'Vazgeç' },
    captureFailed: 'Ekran görüntüsü alınamadı. Dosya yükleyebilirsiniz.',
    fileTooLarge: 'Dosya 5 MB sınırını aşıyor.',
    fileType: 'Bu dosya türü yüklenemez. Kabul edilenler:',
    edit: 'Düzenle',
    annotate: { title: 'Görüntüyü işaretle', rect: 'Kutu', arrow: 'Ok', blur: 'Bulanıklaştır', undo: 'Geri al', clear: 'Temizle', done: 'Tamam', cancel: 'Vazgeç', hint: 'Sorunlu alanı kırmızı kutu ya da okla işaretleyin; gizli bilgiyi bulanıklaştırın.' },
    submit: 'Gönder',
    sending: 'Gönderiliyor…',
    required: 'Bu alan zorunlu.',
    invalidEmail: 'Geçerli bir e-posta girin.',
    success: 'Bildiriminiz alındı.',
    successRef: 'Referans numaranız: {ref}. Cevabı bu pencereden takip edebilirsiniz.',
    another: 'Yeni bildirim',
    viewMine: 'Bildirimlerimi gör',
    error: 'Gönderilemedi. Lütfen tekrar deneyin.',
    rateLimited: 'Çok fazla bildirim gönderdiniz, lütfen biraz bekleyin.',
    limitReached: 'Bildirim limitiniz doldu. Yeni bildirim için lütfen yöneticinizle görüşün.',
    identified: 'Şu kullanıcı olarak gönderiliyor:',
    duplicate: {
      text: 'Bu konuda açık bir talebiniz var: {ref} «{title}». Yazdıklarınızı o talebe ekleyelim mi?',
      add: 'O talebe ekle',
      separate: 'Yeni talep olarak gönder',
      adding: 'Ekleniyor…',
    },
    rec: {
      section: 'Ekran görüntüsü ve kaydı',
      start: 'Ekranı kaydet',
      starting: 'Hazırlanıyor…',
      label: 'Ekran kaydı',
      pages: '{n} sayfa',
      recording: 'Kaydediliyor',
      stop: 'Durdur',
      cancel: 'Kaydı iptal et',
      failed: 'Kayıt başlatılamadı.',
      limit: 'Süre doldu, kayıt durduruldu.',
      tooBig: 'Kayıt çok büyüdü. Lütfen daha kısa bir kayıt deneyin.',
      expired: 'Ekran kaydı (saklama süresi doldu)',
      watch: 'İzle',
      watchFailed: 'Kayıt açılamadı',
    },
  },
  mine: {
    empty: 'Henüz bildiriminiz yok.',
    search: 'Bildirimlerde ara… (başlık, T-12)',
    types: { all: 'Tümü', bug: 'Hata', suggestion: 'Öneri', question: 'Soru', message: 'Mesaj', dev_request: 'Geliştirme İsteği' },
    unreadCount: '{n} okunmamış',
    pin: 'Üste sabitle',
    unpin: 'Sabitlemeyi kaldır',
    pinned: 'Sabitlendi',
    pinFailed: 'Sabitlenemedi. Lütfen tekrar deneyin.',
    noResults: 'Eşleşen bildirim bulunamadı.',
    loadMore: 'Daha fazla göster',
    showing: '{shown} / {total}',
    loading: 'Yükleniyor…',
    error: 'Bildirimler yüklenemedi.',
    reply: 'Cevap yazın…',
    send: 'Gönder',
    you: 'Siz',
    staff: 'Destek',
    attach: 'Ekle',
    replyTo: 'Yanıtla',
    replyingTo: 'Yanıt:',
    jumpToQuoted: 'Alıntılanan mesaja git',
    sendShot: 'Ekran görüntüsü gönder',
    sendFile: 'Dosya gönder',
    uploading: 'Yükleniyor…',
    sendFailed: 'Gönderilemedi. Lütfen tekrar deneyin.',
    resolvedNote: 'Bu bildirim çözüldü olarak işaretlendi.',
    resolvedByYouNote: 'Bu bildirimi çözüldü olarak işaretlediniz.',
    resolveCta: 'Problem Çözüldü',
    edited: 'düzenlendi',
    resolveHint: 'Sorun giderildiyse bu bildirimi kendiniz kapatabilirsiniz.',
    resolveConfirm: 'Bu bildirimi çözüldü olarak işaretleyelim mi?',
    resolveYes: 'Evet, çözüldü',
    resolveCancel: 'Vazgeç',
    resolveFailed: 'İşaretlenemedi. Lütfen tekrar deneyin.',
    planned: 'Planlanan çözüm',
    plannedBetween: '{from} – {until} arasında',
    plannedBy: '{until} tarihine kadar',
    closedNote: 'Bu bildirim kapatıldı.',
    views: { own: 'Bildirimlerim', mentions: 'Bahsedilenler' },
    mentionsEmpty: 'Henüz sizden bahsedilen bir bildirim yok.',
    mentionedYou: '{name} sizden bahsetti',
    mentionedNote: 'Bu bildirimde sizden bahsedildi; cevap yazabilirsiniz.',
    user: 'Kullanıcı',
    mentionPick: 'Kişi etiketle',
    status: { new: 'Bekliyor', in_progress: 'İnceleniyor', queued: 'İşlem listesine alındı', processing: 'İşlemde', waiting_user: 'Cevabınız bekleniyor', resolved: 'Çözüldü', closed: 'Kapandı' },
  },
  q: {
    asked: 'Size soru soruldu',
    answered: 'Sorunuz cevaplandı',
    progress: '{a}/{n} cevaplandı',
    count: '{n} soru',
    placeholder: 'Cevabınızı yazın…',
    send: 'Cevapları gönder',
    pending: 'Cevap bekleyen {n} soru var',
    go: 'Cevapla',
    withdrawn: 'Bu soru geri çekildi',
    unanswered: 'Cevaplanmadı',
    failed: 'Cevaplar gönderilemedi. Lütfen tekrar deneyin.',
  },
  status: {
    ok: 'Bilinen bir sorun yok.',
    loading: 'Kontrol ediliyor…',
    levels: { info: 'Bilgi', warning: 'Uyarı', outage: 'Kesinti' },
    band: 'Bilinen sorun',
    dismiss: 'Kapat',
  },
  poweredBy: 'FETrace',
};

export type Strings = typeof tr;

const en: Strings = {
  launcher: 'Report a problem / support',
  edgeLabel: 'Support',
  title: 'Support',
  subtitle: 'Report a problem, share an idea, follow the reply',
  close: 'Close',
  back: 'Back',
  tabs: { new: 'New report', mine: 'My reports', status: 'Status', pano: 'Statistics' },
  form: {
    type: 'Type',
    types: { bug: 'Bug', suggestion: 'Suggestion', question: 'Question' },
    priority: 'Priority',
    priorities: { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' },
    title: 'Title',
    titlePlaceholder: 'What happened, in short?',
    description: 'Description',
    descriptionPlaceholder: 'What were you trying to do and what happened? Step by step if possible.',
    name: 'Your name',
    email: 'Email',
    screenshot: 'Screenshot',
    capture: 'Capture screen',
    upload: 'Upload file',
    remove: 'Remove',
    capturing: 'Capturing…',
    select: { hint: 'Drag to select the area to capture', full: 'Whole page', cancel: 'Cancel' },
    captureFailed: 'Could not capture the screen. You can upload a file instead.',
    fileTooLarge: 'File exceeds the 5 MB limit.',
    fileType: 'This file type cannot be uploaded. Accepted:',
    edit: 'Edit',
    annotate: { title: 'Annotate screenshot', rect: 'Box', arrow: 'Arrow', blur: 'Blur', undo: 'Undo', clear: 'Clear', done: 'Done', cancel: 'Cancel', hint: 'Mark the problem with a red box or arrow; blur anything private.' },
    submit: 'Send',
    sending: 'Sending…',
    required: 'This field is required.',
    invalidEmail: 'Enter a valid email address.',
    success: 'Your report has been received.',
    successRef: 'Your reference is {ref}. You can follow the reply from this window.',
    another: 'New report',
    viewMine: 'View my reports',
    error: 'Could not send. Please try again.',
    rateLimited: 'Too many reports, please wait a moment.',
    limitReached: 'Your report limit has been reached. Please contact your manager to open a new one.',
    identified: 'Sending as:',
    duplicate: {
      text: 'You already have an open report on this: {ref} “{title}”. Shall we add what you wrote to it?',
      add: 'Add to that report',
      separate: 'Send as a new report',
      adding: 'Adding…',
    },
    rec: {
      section: 'Screenshot and recording',
      start: 'Record screen',
      starting: 'Preparing…',
      label: 'Screen recording',
      pages: '{n} pages',
      recording: 'Recording',
      stop: 'Stop',
      cancel: 'Cancel recording',
      failed: 'Recording could not start.',
      limit: 'Time is up, recording stopped.',
      tooBig: 'The recording got too large. Please record a shorter one.',
      expired: 'Screen recording (retention period over)',
      watch: 'Watch',
      watchFailed: 'Could not open the recording',
    },
  },
  mine: {
    empty: 'You have no reports yet.',
    search: 'Search reports… (title, T-12)',
    types: { all: 'All', bug: 'Bug', suggestion: 'Suggestion', question: 'Question', message: 'Message', dev_request: 'Feature request' },
    unreadCount: '{n} unread',
    pin: 'Pin to top',
    unpin: 'Unpin',
    pinned: 'Pinned',
    pinFailed: 'Could not pin. Please try again.',
    noResults: 'No matching reports.',
    loadMore: 'Show more',
    showing: '{shown} / {total}',
    loading: 'Loading…',
    error: 'Could not load reports.',
    reply: 'Write a reply…',
    send: 'Send',
    you: 'You',
    staff: 'Support',
    attach: 'Attach',
    replyTo: 'Reply',
    replyingTo: 'Replying to',
    jumpToQuoted: 'Jump to the quoted message',
    sendShot: 'Send a screenshot',
    sendFile: 'Send a file',
    uploading: 'Uploading…',
    sendFailed: 'Could not send. Please try again.',
    resolvedNote: 'This report was marked as resolved.',
    resolvedByYouNote: 'You marked this report as resolved.',
    resolveCta: 'Problem solved',
    edited: 'edited',
    resolveHint: 'If the problem is gone, you can close this report yourself.',
    resolveConfirm: 'Mark this report as resolved?',
    resolveYes: 'Yes, it is solved',
    resolveCancel: 'Cancel',
    resolveFailed: 'Could not be marked. Please try again.',
    planned: 'Planned resolution',
    plannedBetween: 'between {from} and {until}',
    plannedBy: 'by {until}',
    closedNote: 'This report was closed.',
    views: { own: 'My reports', mentions: 'Mentions' },
    mentionsEmpty: 'Nobody has mentioned you yet.',
    mentionedYou: '{name} mentioned you',
    mentionedNote: 'You were mentioned in this report; you can reply.',
    user: 'User',
    mentionPick: 'Mention someone',
    status: { new: 'Pending', in_progress: 'In progress', queued: 'Queued', processing: 'Processing', waiting_user: 'Waiting for you', resolved: 'Resolved', closed: 'Closed' },
  },
  q: {
    asked: 'You have been asked',
    answered: 'Answered',
    progress: '{a}/{n} answered',
    count: '{n} questions',
    placeholder: 'Write your answer…',
    send: 'Send answers',
    pending: '{n} questions are waiting for your answer',
    go: 'Answer',
    withdrawn: 'This question was withdrawn',
    unanswered: 'Not answered',
    failed: 'Answers could not be sent. Please try again.',
  },
  status: {
    ok: 'No known issues.',
    loading: 'Checking…',
    levels: { info: 'Info', warning: 'Warning', outage: 'Outage' },
    band: 'Known issue',
    dismiss: 'Dismiss',
  },
  poweredBy: 'FETrace',
};

export function strings(locale: Locale): Strings {
  return locale === 'en' ? en : tr;
}

export function fmt(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ''));
}
